<script setup lang="ts">
import { Button, Search } from 'vant';
import { useOfficialStyle } from './use-official-style.ts';
import { $t } from '@repo/locales';

const props = withDefaults(
  defineProps<{ loading?: boolean }>(),
  { loading: false }
);

const { searchTerms, reload } = useOfficialStyle();

const onSearch = async () => {
  localStorage.setItem('lastCloudPageSearch', searchTerms.value);

  await reload();
};
</script>

<template>
  <Search
    v-model="searchTerms"
    show-action
  >
    <template #action>
      <Button @click="onSearch" size="small" :disabled="props.loading">{{ $t('common.search') }}</Button>
    </template>
  </Search>
</template>

<style scoped>

</style>
